// This plugin is used under the hood for some Kudo components but not explicitly in this codebase
// e.g. comment it out in the Nuxt config and several Kudo components will fail with errors
import KudoID from '@openly-engineering/kudo/plugins/kudo-id'

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.use(KudoID)
})
